import { useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

// Écran chargé à la demande : le portail client et la connexion n'en téléchargent pas le code.
const ManagementScreen = lazy(() => import('../screens/ManagementScreen.js'));

/** « Gestion » (03/10/2026) : `/gestion/<onglet>` (historique, activite, finances). */
export default function ManagementPage() {
  const { tab } = useParams({ strict: false }) as { tab?: string };
  return (
    <GarageGate>
      <ManagementScreen tab={tab ?? null} />
    </GarageGate>
  );
}
